<div class="surface-ground flex align-items-center justify-content-center min-h-screen min-w-screen overflow-hidden">
    <div class="flex flex-column align-items-center justify-content-center p-4">
        <div style="border-radius:46px; padding:0.3rem; background: linear-gradient(180deg, #FF8A00 10%, rgba(247, 149, 48, 0) 30%);">
            <div class="w-full surface-card py-7 px-5 sm:px-8 flex flex-column align-items-center" style="border-radius:43px">
                <img src="assets/logo/ep-icon-no-label.png" alt="Easypick logo" class="mb-5 w-4rem flex-shrink-0">
                <div class="grid flex flex-column align-items-center">
                    <h1 class="text-900 font-bold text-2xl my-2 uppercase">Page not Found</h1>
                    <span class="text-600 mb-2">Uh oh, we cant seem to find the page you are looking for.</span>
                    <img src="assets/svg/404-not-found.svg" alt="Access denied" class="mb-5" width="70%">
                    <p-button 
                        label="Go to Dashboard" 
                        icon="pi pi-arrow-left" 
                        styleClass="gap-2" 
                        [text]="true"
                        (onClick)="goBack()"
                    />
                </div>
            </div>
        </div>
    </div>
</div>